const SET_IS_PRE_DISTRIBUTION_MODAL_SCREEN_OPEN =
  'dashboardScreen/SET_IS_PRE_DISTRIBUTION_MODAL_SCREEN_OPEN';
const SET_IS_COVER_ART_MODAL_SCREEN_OPEN =
  'dashboardScreen/SET_IS_COVER_ART_MODAL_SCREEN_OPEN';
const SET_IS_LOADING_ACCOUNT_MILESTONES =
  'dashboardScreen/SET_IS_LOADING_ACCOUNT_MILESTONES';
const SET_IS_SHOWING_REDIRECTION_CHECK_FAILED_MODAL =
  'dashboardScreen/SET_IS_SHOWING_REDIRECTION_CHECK_FAILED_MODAL';
const SET_IS_SHOWING_REDIRECTION_CHECK_SUCCEEDED_MODAL =
  'dashboardScreen/SET_IS_SHOWING_REDIRECT_CHECK_SUCCEEDED_MODAL';

export default {
  SET_IS_COVER_ART_MODAL_SCREEN_OPEN,
  SET_IS_PRE_DISTRIBUTION_MODAL_SCREEN_OPEN,
  SET_IS_LOADING_ACCOUNT_MILESTONES,
  SET_IS_SHOWING_REDIRECTION_CHECK_FAILED_MODAL,
  SET_IS_SHOWING_REDIRECTION_CHECK_SUCCEEDED_MODAL,
};
